import { SLIDE_STATUS } from '../lib/state/constants'

export const getNumberOfSlides = state =>
  state.sections.reduce((acc, value) => {
    return acc + value.fields.slides.length
  }, 0)
export const getNumberOfCompletedSlides = state =>
  Object.values(state.completeStatus).filter(v => v == SLIDE_STATUS.COMPLETED)
    .length
